import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = React.useState(null);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqs = [
    {
      question: 'How do I claim the PM Surya Ghar Subsidy?',
      answer: 'The PM Surya Ghar subsidy is directly claimed through the National Portal. However, when you purchase a system from SolarSavers, our team and the vendor assist you with the entire documentation process to ensure you get the subsidy credited to your bank account seamlessly.'
    },
    {
      question: 'Are all vendors on SolarSavers verified?',
      answer: 'Yes, absolutely. Every vendor on the SolarSavers platform undergoes a strict vetting process to ensure they have the necessary certifications, technical capabilities, and a track record of quality service.'
    },
    {
      question: 'How long does shipping and installation take?',
      answer: 'Standard shipping of solar components takes 3-7 business days depending on your location. Installation is usually scheduled within 2-3 days after the products arrive at your site. Total turnaround time is typically under 14 days.'
    },
    {
      question: 'Do you offer financing or EMIs?',
      answer: 'Yes! We have partnered with leading banks and NBFCs to provide attractive financing options, including no-cost EMIs and low-interest solar loans to make your transition to renewable energy affordable.'
    },
    {
      question: 'What happens if a component stops working?',
      answer: 'All products sold on our platform come with standard manufacturer warranties (e.g., 25 years for panels). If a component fails within the warranty period, you can raise a ticket from your dashboard, and our support team will coordinate with the manufacturer for replacement.'
    }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow pt-24 bg-background">
        <div className="container-solar py-12 md:py-20 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Frequently Asked <span className="solar-text-gradient">Questions</span>
            </h1>
            <p className="text-lg text-muted-foreground">
              Got questions? We've got answers. If you can't find what you're looking for, feel free to contact our support team.
            </p>
          </motion.div>

          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className="bg-card border border-border rounded-2xl overflow-hidden"
              >
                <button
                  className="w-full px-6 py-5 flex items-center justify-between font-bold text-lg text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  {faq.question}
                  {openIndex === i ? (
                    <ChevronUp className="w-5 h-5 text-primary flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-muted-foreground flex-shrink-0" />
                  )}
                </button>
                <AnimatePresence>
                  {openIndex === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="px-6 pb-5 text-muted-foreground"
                    >
                      {faq.answer}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>

          <div className="mt-16 bg-primary/10 rounded-3xl p-8 text-center border border-primary/20">
             <h3 className="text-xl font-bold mb-3">Still have questions?</h3>
             <p className="text-muted-foreground mb-6">Our support team is ready to help you out.</p>
             <button className="btn-primary" onClick={() => window.location.href='/contact'}>
               Contact Support
             </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FAQPage;
